/**
 * File name display web component.
 * Extracts filename from href of [data-generic-file] links and sets [data-file-name] text.
 */
function extractFilename(url) {
  const pathArray = url.split("/");
  const lastSegment = pathArray[pathArray.length - 1];
  const filename = lastSegment.split("?")[0];
  return filename;
}

class FileNameDisplay extends HTMLElement {
  connectedCallback() {
    this._updateFileNames();
  }

  _updateFileNames() {
    const fileElements = this.querySelectorAll("[data-generic-file]");
    fileElements.forEach((element) => {
      const textElement = element.querySelector("[data-file-name]");
      if (textElement && element.href) {
        textElement.textContent = extractFilename(element.href);
      }
    });
  }
}

customElements.define("file-name-display", FileNameDisplay);
